import { useRef } from 'react';
import { useRouter } from 'next/router';
import useTranslation from 'next-translate/useTranslation';

//hooks
import useRouterQuery from '@/utils/hooks/utils/useRouterQuery';

// Components
import Button from '@/components/base/Button';
import Modal from '@/components/base/Modal';

const EmailUpdateConfirmationSuccessModal = () => {
    const router = useRouter();
    const { t } = useTranslation('commons');
    const { deleteQuery } = useRouterQuery();
    const initRef = useRef(null);

    const closeConfirmationModal = () => {
        const url = deleteQuery('email_updated');
        router.replace(url);
    };

    return (
        <Modal
            open={true}
            withCloseButton={false}
            initialFocus={initRef}
            onDismiss={closeConfirmationModal}>
            <Modal.Body>
                <Modal.Title>{t('email_update.your_email_address_has_been_updated')}</Modal.Title>
                <Modal.Content className="pt-m">
                    <p className="text-center text-base leading-5 text-icoGray-500">
                        {t('email_update.your_email_address_has_been_updated_content')}
                    </p>
                </Modal.Content>
            </Modal.Body>
            <Modal.Footer isRow={false}>
                <Button ref={initRef} size="lg" onClick={closeConfirmationModal}>
                    {t('close')}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default EmailUpdateConfirmationSuccessModal;
